import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH } from '../types/shared';
export const usePersonaCrowd = () => {
    const { request } = useRequest(API_PATH.QUERY_USER_PERSONA);
    const ctx = useMonitorEngineContext();
    /**
     * 查询用户人群归属
     * @param personaIds 人群ID集合
     * @returns 人群信息列表，若请求失败返回 null
     */
    const queryUserPersona = async (personaIds) => {
        try {
            const res = await request({
                personaIds
            });
            if (res?.uni_status_code) {
                ctx?._raptorReport?.monitorReportBizFailed?.();
                return null;
            }
            if (Array.isArray(res?.personaInfoList)) {
                ctx?._raptorReport?.monitorReportBizSuccess?.();
                return res.personaInfoList;
            }
            ctx?._raptorReport?.monitorReportBizFailed?.();
            return null;
        }
        catch (error) {
            ctx?._raptorReport?.monitorReportBizFailed?.();
            return null;
        }
    };
    /**
     * 判断用户是否命中指定人群
     * @param personaIds 人群ID集合
     * @returns Map<personaId, hit>，若请求失败返回空 Map
     */
    const checkPersonaHit = async (personaIds) => {
        const hitMap = new Map();
        const list = await queryUserPersona(personaIds);
        if (!list)
            return hitMap;
        list.forEach(item => {
            hitMap.set(item.personaId, item.hit);
        });
        return hitMap;
    };
    return {
        queryUserPersona,
        checkPersonaHit
    };
};
